import React from "react";
import { ConnectedProps, connect } from "react-redux";
import PaymentOption from "./PaymentOption";
import Title from "./Title";
import { ApplicationState } from "../store";
import { actions } from "./../store/PaymentType";

const PaymentOptions: React.FC<PaymentOptionsProps> = (props: PaymentOptionsProps) => {
  return (
    <div id='ws-paymentOption'>
      <Title title={props?.sectionHeader} />
      {props.paymentTypes?.map((i, key) => (
        <PaymentOption
          key={key}
          code={i.code}
          selected={i.selected}
          title={i.title}
          description={i.description}
          secondaryText={i.secondaryText}
          available={i.available}
          paymentPeriods={i.paymentPeriods}
          bankList={i.bankList}
          bankHelperText={i.bankHelperText}
          bankChanged={props.bankChanged}
          paymentTypeChanged={props.paymentTypeChanged}
          paymentPeriodChanged={props.paymentPeriodChanged}
          showError={props.showError}
          selectedPaymentTypeCode={props.selectedPaymentTypeCode}
          selectedBankCode={props.selectedBankCode}
          digitalSigning={props.digitalSigning}
        />
      ))}
    </div>
  );
};

const connector = connect((state: ApplicationState) => state.payment, {
  paymentTypeChanged: actions.paymentTypeChanged,
  paymentPeriodChanged: actions.paymentPeriodChanged,
  bankChanged: actions.bankChanged,
});

type PaymentOptionsProps = ConnectedProps<typeof connector> & {};

export default connector(PaymentOptions);
